import Vue from 'vue';

export const formCaches = {
  namespaced: true,
  state: () => {
    return {
      caches: {},
    };
  },
  getters: {
    getCachedForm: (state) => (id) => {
      return state.caches[id] ?? null;
    },
  },
  mutations: {
    saveForm: (state, { id, data }) => {
      Vue.set(state.caches, id, data);
    },

    removeCachedForm: (state, id) => {
      Vue.set(state.caches, id, null);
    },
  },
};
